import { render, staticRenderFns } from "./SubscribeView.vue?vue&type=template&id=5734b6d2&scoped=true&"
import script from "./SubscribeView.vue?vue&type=script&lang=js&"
export * from "./SubscribeView.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeView.vue?vue&type=style&index=0&id=5734b6d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5734b6d2",
  null
  
)

export default component.exports